module.exports = __webpack_public_path__ + "media/assets/images/votorantim-banco@2x-38b730892ef66613c8de56a1c14898f0.png";